import src from "IMAGE";
export default { src, width: 56, height: 56, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAANElEQVR42q2OOw4AIAxC+Th4/xMbhiadrINvAhICwAu2t6RVPjoZekBS5aN74QPjxHjyxgFXbACpxhtz+gAAAABJRU5ErkJggg=="};
